import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';

const changeAddressAcceptance = async ({ flatId, AcceptanceStatusId }) => {
  const res = await request.put(
    `/FlatsGrid/change_acceptance_result_address_life_cycle/${flatId}`,
    { AcceptanceStatusId },
    'Не удалось изменить стутас приемки',
  )
  return res;
}

const useChangeAddressAcceptance = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(changeAddressAcceptance, {
    onSuccess: (data, {flatsGridQueryKey}) => queryClient.invalidateQueries(flatsGridQueryKey),
  })

  return {
    chengeAsync: mutation.mutateAsync,
    loading: mutation.isLoading,
  }
}

export { useChangeAddressAcceptance }